import { Pipe, PipeTransform } from '@angular/core';

import { timeDifference } from '@src/app/utils/date';

@Pipe({
  name: 'timeDifference'
})
export class TimeDifferencePipe implements PipeTransform {

  transform(start: any, end: any): string {
    return timeDifference(start, end);
  }

}
